// Vuex
import {mapActions} from 'vuex';
import * as PATIENT from '@/store/constants/patient';

// Components
import PersonalInformationForm from '../Form/PersonalInformationForm';
import OtherInformationForm from '../Form/OtherInformationForm';
import InsuranceForm from '../Form/InsuranceForm';
import ContactForm from '../Form/ContactForm';
import Notification from '@/views/Common/Notification';

import NotificationMixin from '@/mixins/notification';
import PayloadMerger from '@/mixins/payload-merger';

export default {
  name: "PatientEdit",

  data() {
    return {
      patient: {}
    }
  },

  mixins: [PayloadMerger, NotificationMixin],
  components: {
    PersonalInformationForm,
    OtherInformationForm,
    InsuranceForm,
    ContactForm,
    Notification
  },

  computed: {
    fullName() {
      return (this.patient)
        ? this.patient.last_name + ' ' + this.patient.first_name
        : null;
    }
  },

  methods: {
    ...mapActions({
      handleEdit: PATIENT.ACTION_EDIT
    }),

    save() {
      this.resetNotification();

      const personalInfo = this.$refs['personal-info-tab'].$data['personal_info'];
      const additionalPayloadRefs = ['other-info-tab', 'insurance-tab', 'contact-tab'];

      let payload = {...personalInfo};

      for (let refs of additionalPayloadRefs) {
        payload = this.mergePayload(payload, this.$refs[refs].$data)
      }

      this.handleEdit({id: this.patient.id, payload}).then(() => {
        this.showSuccessNotification('Patient record successfully updated.');
      }).catch(err => {
        let message = JSON.parse(err.response.data.message);
        message = Object.values(message).join("<br>");
        this.showErrorNotification(message);
      })
    },

    back() {
      this.$router.push(
        {
          name: 'PatientDetail',
          params: {id: this.patient.id, patient: this.patient}
        }
      );
    }
  },

  created() {
    if (this.$route.params['patient']) {
      this.patient = this.$route.params['patient'];
    } else {
      this.$router.back();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Patient/js/patient-edit.js